import { z } from 'zod';
import { getEmailSchema, phoneSchema } from '../sharedValidations';
import errors from '../errors';

export const askSupportSchema = (lang: 'en' | 'de') =>
  z.object({
    email: getEmailSchema(lang),
    company: z.string().min(1, errors.required[lang]),
    contact_person: z.string().min(1, errors.required[lang]),
    phone: phoneSchema(lang, false), // optional
    'g-recaptcha-response': z.string().optional(),
  });
